import { render, staticRenderFns } from "./OrderDetail.vue?vue&type=template&id=3e21dcac&scoped=true"
import script from "./OrderDetail.vue?vue&type=script&lang=js"
export * from "./OrderDetail.vue?vue&type=script&lang=js"
import style0 from "./OrderDetail.vue?vue&type=style&index=0&id=3e21dcac&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e21dcac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e21dcac')) {
      api.createRecord('3e21dcac', component.options)
    } else {
      api.reload('3e21dcac', component.options)
    }
    module.hot.accept("./OrderDetail.vue?vue&type=template&id=3e21dcac&scoped=true", function () {
      api.rerender('3e21dcac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rsManagement/orderList/components/OrderDetail.vue"
export default component.exports